/* eslint-disable react-hooks/exhaustive-deps */
import {
    useEffect,
    type RefObject,
    type DependencyList
} from "react";

export const useAutoScrollBottom = (containerRef: RefObject<HTMLElement>, deps: DependencyList) => {
    useEffect(() => {
        const el = containerRef.current;

        if (el) {
            el.scrollTop = el.scrollHeight;
        }
    }, [...deps, containerRef.current]);
};

export default useAutoScrollBottom;
